export const EVENTS_ROUTES = {
  __ROOT__: '/events',
  EDIT_EVENT: '/events/edit/:eventId',
  NEW_EVENT: '/events/new/:type',
  VIEW_EVENT: '/events/view/:eventId',
}
